<template>
  <div class="cc-tab-content" >
      <div class="cctc-title">
        <div class="info">
          已有
          <span class="num">{{totalCount}}</span> 名专业买家完成审核
        </div>
        <div class="change" @click="init()">换一组</div>
        <!-- <div class="btn">
          <van-button plain hairline type="info" color="#fff" size="small">筛选</van-button>
        </div> -->
      </div>
    <van-list v-model="Loading" :finished="finished" >
      <div class="cc-box2">
        <div class="cc-list2" @click="LinkConnectionDetails(item.inMemberId)" v-for="(item, index) in List" :key="'cc-list2-' + index">
          <div class="cc-list2-t">
            <div class="logo">
              <img
                :src="item.avatarUrl?item.avatarUrl:'https://ss2.bdstatic.com/70cFvnSh_Q1YnxGkpoWK1HF6hhy/it/u=188149577,2949073731&fm=26&gp=0.jpg'"
                v-load="'oAvatar'"
              />
            </div>
            <div class="details">
              <div class="line van-ellipsis">
                <span class="name ">{{item.name?item.name:'--'}}</span>
                <span class="job ">{{item.jobTitle?item.jobTitle:'--'}}</span>
              </div>
              <div class="interest" v-if="item.category">
                <div v-for="(mode,ind) in getCateList(item.category)" :key="ind">
                  <span>{{mode}}</span>
                </div>
              </div>
              <!-- <div class="info2">170****4588</div> -->
            </div>
            <!-- <div class="txt">已有23人向他打招呼</div> -->
          </div>
          <p class="cc-list2-gx">
            供需：<span v-if="item.business"  >{{getBuContetn(item.business)}}</span>
            <span v-else style="color:#bfbfbf">他还没有发布供需~</span>
          </p>
          <!-- <div class="cc-list2-b">
            <div class="cclb-l">
              <div class="txt2">我想找个美妆加工厂</div>
              <div class="txt3">#这里是话题的名字</div>
            </div>
            <div class="cclb-r">
              <div class="btn">打招呼</div>
            </div>
          </div> -->
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "major-list",
  data() {
    return {
      Loading: false, //专业买家动态加载状态
      finished: false, //专业买家加载是否完成状态
      List: [], //专业买家列表
      pageSize:12,
      totalCount: 0,
    };
  },
  components: {},
  computed: {
    ...mapGetters({
      exhibitionId: "getExhibitionId",
      userId: "getUserId"
    }),
  },
  created() {this.init()},
  methods: {
    ...mapActions({
      getMajorList: "connection/getMajorList",
      LinkConnectionDetails:'linkTo/LinkConnectionDetails',
    }),
    //得到选择的感兴趣
    getCateList(str){
      let option=JSON.parse(str);
      let cateList=[];
      option.forEach(el => {
          el.Lists.forEach(model=>{
            cateList.push(model.Value);
          })
      });
      return cateList
    },
    
    //得到供需内容
    getBuContetn(str){
      return JSON.parse(str).content
    },
    //得到供需图片List
    getBuImgList(str){
      return JSON.parse(str).imgList
    },
    async init() {
      this.List=[];
      this.finished = false;
      this.Loading = true;
      const data = await this.getMajorList(this.exhibitionId);
      if (!data) {
        this.Loading = false;
        this.finished = true;
        return;
      }
      this.List.push(...data.userList);
      this.totalCount = data.total;
      this.Loading = false;
      this.finished = true;
    },
    //跳转打招呼
    toGreet(){
 
    },
  }
};
</script>

<style scoped lang="scss">
//专业买家内容
 .cc {
  &-tab {
    &-content {
      padding-top: 0.7rem;
      .cctc-title {
        position: fixed;
        z-index: 99;
        top: 1rem;
        left: 0;
        right: 0;
        background:#131825;
        display: flex;
        padding: 0.14rem 0.24rem 0.14rem;
        align-items: center;
        justify-content: space-between;
        .info {
          font-size: 0.2rem;
          color: #bfbfbf;
          margin-right: 0.2rem;
          max-width: 50%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          .num {
            color: #fff;
          }
        }
        .change {
          color: #f85b0f;
        }
        .btn {
          flex: 1;
          text-align: right;
          button {
            background-color: transparent;
          }
        }
      }
    }
  }
  &-box {
    padding: 0 0.24rem;
  }
  &-list {
    margin-bottom: 0.2rem;
    padding: 0.2rem;
    background-color: #1d2435;
    display: flex;
    &-l {
      width: 1.8rem;
      height: 2.3rem;
      border-radius: 0.05rem;
      position: relative;
      margin-right: 0.17rem;
      img {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        margin: auto;
        max-width: 100%;
        max-height: 100%;
        background-color: #ff4550;
        border-radius: 0.05rem;
      }
    }
    &-r {
      width: calc(100% - 1.97rem);
      color: #fff;
      .title {
        font-size: 0.24rem;
        margin-bottom: 0.16rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .info {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        font-size: 0.2rem;
        margin-bottom: 0.5rem;
      }
      .txt {
        font-size: 0.18rem;
        color: #bfbfbf;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  &-box2 {
    padding: 0 0.24rem;
    .cc-list2 {
      padding: 0.2rem;
      margin-bottom: 0.2rem;
      background-color: #1d2435;
      border-radius: 0.05rem;
      color: #fff;
      &-t {
        margin-bottom: 0.28rem;
        display: flex;
        .logo {
          position: relative;
          flex-shrink:0;
          width: 0.88rem;
          height: 0.88rem;
          margin-right: 0.14rem;
          img {
            border-radius: 50%;
            width: 100%;
            height: 100%;
            // object-fit: cover;
          }
        }
        .details{
          .line {
            display: flex;
            align-items: flex-end;
            margin-bottom: 0.23rem;
            // padding-top: 0.1rem;
            .name {
              font-size: 0.24rem;
              margin-right: 0.1rem;
              font-weight: 400;
            }
            .job {
              font-size: 0.2rem;
            }
          }
          .interest {
            display: flex;
            flex-wrap: wrap;
            min-height: 0.32rem;
            div{
              margin:0 0.1rem 0.1rem 0;
              display: flex;
              justify-items: center;
              align-items: center;
              text-align: center;
              height: 0.32rem;
              background: #333d56;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              border-radius: 0.03rem;
              padding: 0 0.11rem;
              span{
                font-size: 0.2rem;
              }
            }
          }
          .info2 {
            font-size: 0.2rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .txt {
          width: 2rem;
          padding-top: 0.16rem;
          text-align: right;
          font-size: 0.2rem;
          color: #bfbfbf;

          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      &-gx{
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      &-b {
        display: flex;
        .cclb {
          &-l {
            font-size: 0.2rem;
            width: 80%;
            padding-top: 0.13rem;
            .txt2 {
              color: #ffcc00;
              width: calc(100% - 1px);
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .txt3 {
              width: calc(100% - 1px);
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          &-r {
            width: 20%;
            text-align: right;
            .btn {
              height: 0.48rem;
              line-height: 0.48rem;
              display: inline-block;
              padding: 0 0.2rem;
              background-color: #f85b0f;
              border-radius: 0.04rem;
            }
          }
        }
      }
    }
  }
  }
</style>
